module.exports = __webpack_public_path__ + "img/userA02.6499f4b6.jpg";